export default __webpack_public_path__ + "static/media/200.59c7e7a4.gif";